import script from "./VehicleNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./VehicleNumberInput.vue?vue&type=style&index=0&id=002064c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002064c2"]])

export default __exports__